/* global SETTINGS */
import { get, set, isObject, has } from 'lodash-es'
import { getTranslationData } from '@/js/helper/settings-filter.js'

import en from './settings/settings-en.json'
import de from './settings/settings-de.json'
import es from './settings/settings-es.json'
import fr from './settings/settings-fr.json'
import nl from './settings/settings-nl.json'
import cs from './settings/settings-cs.json'

const allSettings = {
  en: {
    ...en,
    filter: getTranslationData(),
  },
  de,
  es,
  fr,
  nl,
  cs,
}

// If feature 'fe-settings-override' is enabled.
// We get the GLOBAL SETTINGS var and overreide the settings
// format: [[<string: path>, value]]
// local .env: BU_SETTINGS_OVERRIDE="[[\"filter.config.scope.ARCHIVE.items.ProductSeason.2022\", {}]]"
// server deployment: SETTINGS="[["filter.config.scope.ARCHIVE.items.ProductSeason.2022", {}]]"

export const getSettingsInLaguage = lang => {
  const settings = get(allSettings, lang, {})
  // eslint-disable-next-line spaced-comment
//////////////////////////////////////////
////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////
////////////////////////////
/////////////////////////////
///////////////////////////////
/////
////
////////////////////
////////////////////////////////////////////
////////////
  return settings
}
